module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Slopefailure/Nagano_Slopefailure_GFDL_RCP45_Mid.png";